import UserFieldBase from "./base";

export default class UserFieldText extends UserFieldBase {}
